import { Link, useLocation } from "react-router-dom";
// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
  Nav,
  NavItem,
  Container,
  Media,
} from "reactstrap";
import { HandleLogout } from "utils/Logout";
import { ThemeToggle } from "components/shared";

const AdminNavbar = (props) => {
  const location = useLocation();

  return (
    <>
      {location.pathname.includes("/admin/edit-game") ? null : (
        <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
          <Container fluid>
            <Link className="mb-0 text-white h4 text-uppercase d-none d-lg-inline-block" to="/">
              {props.brandText}
            </Link>
            <Nav className="align-items-center d-none d-md-flex" navbar>
              <NavItem className="mr-2">
                <ThemeToggle />
              </NavItem>
              <UncontrolledDropdown nav>
                <DropdownToggle className="pr-0" nav aria-label="Open user menu">
                  <Media className="align-items-center">
                    <span className="avatar avatar-sm rounded-circle">
                      <img alt="AKH Dashboard user avatar" src={require("../../assets/img/logo.jpg")} />
                    </span>
                    <Media className="ml-2 d-none d-lg-block">
                      <span className="mb-0 text-sm font-weight-bold">
                        {sessionStorage.getItem("username")}
                      </span>
                    </Media>
                  </Media>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-arrow" right>
                  <DropdownItem className="noti-title" header tag="div">
                    <h6 className="m-0 text-overflow">Welcome!</h6>
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem onClick={() => HandleLogout()}>
                    <i className="ni ni-user-run" />
                    <span>Logout</span>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Container>
        </Navbar>
      )}
    </>
  );
};

export default AdminNavbar;
